import React, { ReactNode, Suspense } from 'react'
import Paths, { paths } from './IconPaths'
import IconProps from './IconProps'
import Img from './Img'

export const tuple = <T extends string[]>(...args: T) => args
const IconNames = tuple(...Object.keys(paths))
export type IconNameTypes = (typeof IconNames)[number];

interface NamedIconProps extends IconProps {
  name?: IconNameTypes;
  iconFallback?: IconNameTypes;
  style?: object;
  className?: any;
  onClick?: React.MouseEventHandler<HTMLElement>;
  imgTag?: boolean
  imgAlt?: string
  alt?: string
  imgFallback?: string
}

export default class Icon extends React.Component<NamedIconProps> {
  static defaultProps = {
    style: {},
    className: null,
    imgTag: false
  }

  render(): ReactNode {
    const { name, iconFallback, imgTag, imgAlt,alt, imgFallback, ...props } = this.props
    const NamedIcon = Paths.get(name)
    if (NamedIcon == null || imgTag) {
      if (imgFallback) {
        return <Img alt={ imgAlt } src={ imgFallback } {...props}/>
      } else {
        const FallbackNamedIcon = Paths.get(iconFallback)
        if (FallbackNamedIcon == null) {
          return null
        }
        return <Suspense fallback={ '' }><FallbackNamedIcon alt={imgAlt || alt} { ...props }/></Suspense>
      }
    }

    return <Suspense fallback={ '' }><NamedIcon alt={imgAlt || alt} name={name} { ...props }/></Suspense>
  }
}
